export default __webpack_public_path__ + "static/media/family.faed52a9.jpg";